function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { isNode } from "browser-or-node";
import fetch from "cross-fetch";
import { nanoid } from "nanoid";
const endpoint = "https://api.superwall.dev";
class SWEventsClient {
    configure(apiKey, { requestId } = {}) {
        this.apiKey = apiKey;
        this._requestId = requestId;
    }
    requestId(requestId) {
        const newClient = new SWEventsClient();
        newClient.configure(this.apiKey || undefined, {
            requestId
        });
        return newClient;
    }
    capture(name, event, metadata = {}) {
        var _this = this;
        return _async_to_generator(function*() {
            const baseEvent = {
                id: nanoid(),
                ts: new Date().toISOString(),
                metadata: _object_spread({}, metadata, isNode ? {
                    hostname: _this._hostname,
                    release: _this._release
                } : {})
            };
            // We have to ignore here b/c I couldn't get tsc to figure
            // out that the event is a narrowed type ofTSWEvent
            //@ts-ignore
            return _this.publish([
                //@ts-ignore
                _object_spread_props(_object_spread({}, baseEvent), {
                    name,
                    event
                })
            ]);
        })();
    }
    captureMany(events) {
        var _this = this;
        return _async_to_generator(function*() {
            return _this.publish(//@ts-ignore
            events.map((e)=>_object_spread_props(_object_spread({}, e), {
                    id: nanoid(),
                    ts: new Date().toISOString(),
                    metadata: {}
                })));
        })();
    }
    publish(events) {
        var _this = this;
        return _async_to_generator(function*() {
            const resolvedEndpoint = process.env.NEXT_PUBLIC_SWEVENTS_ENDPOINT || endpoint;
            const url = `${resolvedEndpoint}/api/internal/events`;
            const result = yield fetch(url, {
                // https://stackoverflow.com/questions/40523469/navigator-sendbeacon-to-pass-header-information
                keepalive: true,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${_this.apiKey}`
                },
                body: JSON.stringify({
                    events
                })
            }).then((r)=>r.json()).catch((e)=>{
            // console.error(`[SWEventsClient] Error publishing event: ${e}, ${e.body}`)
            });
            // console.log(
            //   `[SWEventsClient] Published event: ${JSON.stringify(events)}, result: ${JSON.stringify(
            //     result
            //   )}`
            // )
            return result;
        })();
    }
    constructor(){
        _define_property(this, "apiKey", void 0);
        _define_property(this, "_requestId", void 0);
        _define_property(this, "_hostname", void 0);
        _define_property(this, "_release", void 0);
    }
}
export { SWEventsClient };
